import _ from 'lodash';
import { ref } from '@vue/composition-api';
import { $api } from '@/store/ApiClient';
import { generateUuid, mapToSchemaList } from '@/utils/searchUtil.js';
import sampleData from '@/sampleData/tradingManageEditorResSample.json';

// const isMock = true;
const isMock = false;

export function useBffTradingManagesEditor(options = {}) {
  const {
    path: initialPath = {},
    queries: initialQueries = {},
    tradingFlowId = '',
    immediate = true,
  } = options;

  const data = ref(null);
  const tradingInfo = ref(null);
  const flowInfo = ref(null);
  const processList = ref(null);
  const processData = ref(null);
  const tmpProcessData = ref([]);
  const loading = ref(false);
  const error = ref(null);
  const forbidden = ref(false)
  const cancelRequestSources = [];
  const tag = generateUuid();
  cancelRequestSources.push(tag);

  const fetchData = async (options = {}) => {
    loading.value = true;
    error.value = null;
    const params = {
      lslConfig: {
        serviceCode: 'tw-transaction-bff-api',
        apiCode: 'get_/v1/tradings/{companyId}/manages/editor',
        path: options?.path || initialPath,
        query: options?.queries || initialQueries,
      },
      tag: cancelRequestSources,
    };
    try {
      if (isMock) {
        data.value = sampleData;

        tradingInfo.value = sampleData.tradingInfo;
        if (tradingFlowId !== 'new') {
          flowInfo.value = sampleData.tradingInfo.tradingFlowList.find(
            flow => flow.tradingFlowId === tradingFlowId,
          );
          processData.value = mapToSchemaList(flowInfo.value);
        }
        tmpProcessData.value =
          tradingInfo.value?.tradingPatternInfo?.tmpTradingFlowList[0].tmpProcessList;
        processList.value = sampleData.processList;
      } else {
        const res = await $api.request(params);
        data.value = res;

        tradingInfo.value = res.tradingInfo;
        if (tradingFlowId !== 'new') {
          flowInfo.value = res.tradingInfo.tradingFlowList.find(
            flow => flow.tradingFlowId === tradingFlowId,
          );
          processData.value = mapToSchemaList(flowInfo.value);
        }
        tmpProcessData.value =
          tradingInfo.value?.tradingPatternInfo?.tmpTradingFlowList[0].tmpProcessList;
        processList.value = res.processList;
        return res;
      }
    } catch (err) {
      error.value = err;
      if ( err.statusCode === 403 ) {
        forbidden.value = true
      }
    } finally {
      loading.value = false;
    }
  };

  if (immediate) fetchData();

  return {
    data,
    tradingInfo,
    flowInfo,
    tmpProcessData,
    processData,
    processList,
    loading,
    error,
    forbidden,
    fetchData,
    mapToSchemaList,
  };
}
